import React from 'react';
import dayjs from 'utils/dayjs';

import { getPropsFromFigures } from './utils';
import Card from './card';

import './cardsList.style.css';

const cardsList = ({
    cards,
    cardClicked,
    dateDisplayFormat,
    compareDates,
    showChange,
    showBudget,
    showForecast,
    currency,
}) => {
    const filler = Array.from({ length: 6 }, (v, i) => <div key={`Empty${i}`} className="CardsListEmptyCard" />);
    return (
        <div className="CardsListWrapper">
            <div className="CardsList">
                {cards.map((row) => {
                    const isSameOrFuture = compareDates(row.date, dayjs()) !== -1;
                    const shouldShowChange = showChange && isSameOrFuture;
                    const cardProps = {
                        date: row.date.format(dateDisplayFormat),
                        dateNotFormatted: row.date,
                        currency,
                        cardClicked,
                        showUnguaranteed: isSameOrFuture,
                        showChange: shouldShowChange,
                        showBudget,
                        showForecast,
                        isLySpit: isSameOrFuture,
                        ...getPropsFromFigures(row),
                    };
                    if (shouldShowChange) {
                        cardProps.change = row.change.gain.guaranteed.rooms - row.change.loss.rooms;
                    }
                    return <Card key={cardProps.date} {...cardProps} />;
                })}
                {filler}
            </div>
        </div>
    );
};

export default cardsList;
